class Dropdowns {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$dropdowns = this.el.querySelectorAll('.dropdowns__dropdown')
    this.ui.$buttons = this.el.querySelectorAll('.dropdowns__dropdown-header-right')
  }
  
  bindEvents() {
    for (let i = 0; i < this.ui.$buttons.length; i++) {
      this.ui.$buttons[i].addEventListener('click', this.toggle.bind(this))
      this.ui.$buttons[i].addEventListener('keydown', this.onKeyDown.bind(this))
    }
  }

  onKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.toggle(e)
    }
  }

  toggle(e) {
    e.preventDefault()
    let target = e.currentTarget
    let dropdown = target.closest('.dropdowns__dropdown')
    let content = dropdown.querySelector('.dropdowns__dropdown-content')
    let title = dropdown.querySelector('.dropdowns__dropdown-header-title').textContent
    
    if (dropdown.classList.contains('is-open')) {
      this.close(dropdown, content, target, title)
    } else {
      this.open(dropdown, content, target, title)
    }
  }

  open(dropdown, content, button, title) {
    dropdown.classList.add('is-open')
    button.classList.add('is-open')
    content.classList.add('is-open')
    content.style.maxHeight = `${content.scrollHeight}px`
    
    // Mise à jour des attributs d'accessibilité
    button.setAttribute('aria-expanded', 'true')
    button.setAttribute('aria-label', `Fermer ${title}`)
    content.setAttribute('aria-hidden', 'false')
    content.setAttribute('aria-expanded', 'true')
  }

  close(dropdown, content, button, title) {
    dropdown.classList.remove('is-open')
    button.classList.remove('is-open')
    content.classList.remove('is-open')
    content.style.maxHeight = '0'
    
    // Mise à jour des attributs d'accessibilité
    button.setAttribute('aria-expanded', 'false')
    button.setAttribute('aria-label', `Ouvrir ${title}`)
    content.setAttribute('aria-hidden', 'true')
    content.setAttribute('aria-expanded', 'false')
  }
}

export default Dropdowns 